import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useMemo as m, useState as r } from "react";
import { usePopper as f } from "react-popper";
var y = function y(_ref) {
  var _ref$offset = _ref.offset,
    l = _ref$offset === void 0 ? [0, 10] : _ref$offset;
  var _r = r(null),
    _r2 = _slicedToArray(_r, 2),
    e = _r2[0],
    o = _r2[1],
    _r3 = r(null),
    _r4 = _slicedToArray(_r3, 2),
    t = _r4[0],
    s = _r4[1],
    _f = f(e, t, {
      placement: "bottom",
      strategy: "fixed",
      modifiers: [{
        name: "offset",
        options: {
          offset: l
        }
      }]
    }),
    p = _f.styles,
    n = _f.attributes;
  return m(function () {
    return {
      element: e,
      setElement: o,
      popper: t,
      setPopper: s,
      styles: p,
      attributes: n
    };
  }, [e, o, t, s, p, n]);
};
export { y as useSelectPopper };